interface SetCheckboxValueProps<T extends string> {
  selectedValues?: T[]
  value: T
}

export function setCheckboxValue<T extends string>({
  selectedValues,
  value,
}: SetCheckboxValueProps<T>): T[] {
  if (selectedValues) {
    const isCurrentValuePreviouslySelected = selectedValues.includes(value)

    const updatedSelectedValues = isCurrentValuePreviouslySelected
      ? selectedValues.filter(selected => selected !== value)
      : [...selectedValues, value]

    return updatedSelectedValues.length > 0 ? updatedSelectedValues : []
  }

  return []
}
